import React from 'react';
export function Footer() {
  return <footer className="bg-brand-light px-4 py-4 text-center" data-id="element-67" data-mp="32wd0e9mw79qd">
      <div className="mx-auto max-w-3xl space-y-1" data-id="element-68" data-mp="3gfsoqi9xf4pm">
        <p className="text-[11px] font-semibold text-brand-ink sm:text-xs" data-id="element-69" data-mp="3ghc3g4fxp7pa">
          © 2026 SMART HOME INSTALLER PRO™ — All Rights Reserved.
        </p>
        <p className="text-[11px] font-normal leading-snug text-brand-muted sm:text-xs" data-id="element-70" data-mp="36ooajks2rnvu">
          This training program is provided for educational purposes and is designed to teach Smart
          Home installation principles, automation systems, and professional workflows. Students
          should always follow local electrical regulations, manufacturer guidelines, safety
          standards, and applicable laws when performing any installation.
        </p>
        <p className="text-[11px] font-medium text-brand-muted sm:text-xs" data-id="element-71" data-mp="29z6t68jqcdeb">
          Terms &amp; Conditions • Privacy Policy • Contact
        </p>
        <p className="text-[11px] font-medium text-brand-muted sm:text-xs" data-id="element-72" data-mp="2ez1l8ff8r90y">
          Support:{' '}
          <a href="mailto:kitonline27@gmail.com" className="font-semibold text-brand-orange hover:underline" data-id="element-73" data-mp="3labr7utqu4pu">
            kitonline27@gmail.com
          </a>
        </p>
      </div>
    </footer>;
}